module.exports = __webpack_public_path__ + "img/declineButtonImage.c9a12e66.png";